import { NgModule } from '@angular/core';
import { FnCustomCarousalComponent } from './fn-custom-carousal.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FnInputModule} from './../input/index';
import { FoundationModule } from '../../foundation.module';
export * from './fn-custom-carousal.component';

/**
 * Exports the required FnCustomCarousalComponent to create carousal Element
 * making them available for import by NgModules that import this module.
 */

@NgModule({
    declarations: [FnCustomCarousalComponent],
    imports: [
        CommonModule,
        FormsModule,
        FoundationModule,
        FnInputModule
    ],
    exports: [FnCustomCarousalComponent],
})
export class FnCustomCarousalModule { }
